module.exports = __webpack_public_path__ + "static/img/113_TO8_1636.ba246a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/113_TO8_1636.jpg
// module id = 7ykH
// module chunks = 0